import { render, staticRenderFns } from "./bg.vue?vue&type=template&id=fb827136&scoped=true&"
import script from "./bg.vue?vue&type=script&lang=js&"
export * from "./bg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb827136",
  null
  
)

export default component.exports